import { createContext } from "react";

/** A visible interaction owns the reading position until it closes or the person follows the latest messages. */
export const ConversationViewport = createContext<((element: HTMLElement) => () => void) | null>(null);
